export const EDITOR_FOCUS_ANNOTATION = 'EDITOR_FOCUS_ANNOTATION';
export const EDITOR_FOCUS_COMMENT_THREAD = 'EDITOR_FOCUS_COMMENT_THREAD';
export const EDITOR_FOCUS_REACTION = 'EDITOR_FOCUS_REACTION';
export const EDITOR_BLUR_MAGNETIC_WALL = 'EDITOR_BLUR_MAGNETIC_WALL';
export const EDITOR_HIGHLIGHT_ANNOTATION = 'EDITOR_HIGHLIGHT_ANNOTATION';
export const EDITOR_HIGHLIGHT_COMMENT_THREAD =
  'EDITOR_HIGHLIGHT_COMMENT_THREAD';
export const EDITOR_HIGHLIGHT_REACTION = 'EDITOR_HIGHLIGHT_REACTION';
export const EDITOR_REMOVE_MAGNETIC_WALL_HIGHLIGHT =
  'EDITOR_REMOVE_MAGNETIC_WALL_HIGHLIGHT';
export const EDITOR_HIGHLIGHT_ANNOTATION_ID = 'EDITOR_HIGHLIGHT_ANNOTATION_ID';
export const EDITOR_EDITING_LINK = 'EDITOR_EDITING_LINK';
export const EDITOR_PICKING_REACTION = 'EDITOR_PICKING_REACTION';
export const EDITOR_LEAVE = 'EDITOR_LEAVE';
export const EDITOR_LOAD = 'EDITOR_LOAD';
export const EDITOR_LOCK = 'EDITOR_LOCK';
export const EDITOR_READ_ONLY = 'EDITOR_READ_ONLY';
export const EDITOR_TITLE_UPDATE = 'EDITOR_TITLE_UPDATE';

export const EDITOR_PRESENCE = 'EDITOR_PRESENCE';

export const EDITOR_LOCAL_UPDATED = 'EDITOR_LOCAL_UPDATED';
export const EDITOR_REMOTE_UPDATED = 'EDITOR_REMOTE_UPDATED';

export const EDITOR_TRANSMIT_STATE_CHANGE = 'EDITOR_TRANSMIT_STATE_CHANGE';
export const EDITOR_SELECTION_REMOTE = 'EDITOR_SELECTION_REMOTE';
export const EDITOR_SELECTION_TRANSMITTED = 'EDITOR_SELECTION_TRANSMITTED';

export const EDITOR_SAVE_STATUS_CHANGE = 'EDITOR_SAVE_STATUS_CHANGE';
export const EDITOR_SYNC_STATE_CHANGE = 'EDITOR_SYNC_STATE_CHANGE';
export const EDITOR_SYNC_STATUS_CHANGE = 'EDITOR_SYNC_STATUS_CHANGE';

export const EDITOR_SET_HAS_STATE_BAR = 'EDITOR_SET_HAS_STATE_BAR';
export const EDITOR_SET_POST_BANNER_POPOVER_OPEN =
  'EDITOR_SET_POST_BANNER_POPOVER_OPEN';
export const EDITOR_SET_IS_POSITIONING_POST_BANNER =
  'EDITOR_SET_IS_POSITIONING_POST_BANNER';
export const EDITOR_SET_CURRENT_POST_BANNER = 'EDITOR_SET_CURRENT_POST_BANNER';

export const ONBOARDING_DATA_SET = 'ONBOARDING_DATA_SET';
export const ONBOARDING_TUTORIAL_ACTIVE_SET = 'ONBOARDING_TUTORIAL_ACTIVE_SET';
export const ONBOARDING_TUTORIAL_BEACONS_SET =
  'ONBOARDING_TUTORIAL_BEACONS_SET';

export const ORGANIZATION_UPDATED = 'ORGANIZATION_UPDATED';

export const SESSION_ORGANIZATION = 'SESSION_ORGANIZATION';
export const SESSION_START = 'SESSION_START';
export const SESSION_USER = 'SESSION_USER';
export const SESSION_USER_SETTING = 'SESSION_USER_SETTING';

export const UI_MODAL_CLOSE = 'UI_MODAL_CLOSE';
export const UI_MODAL_OPEN = 'UI_MODAL_OPEN';
export const UI_MENTION_INTEGRATION_PROMPT_HIDE =
  'UI_MENTION_INTEGRATION_PROMPT_HIDE';
export const UI_STICKY_TOC_PREFERRED_SET = 'UI_STICKY_TOC_PREFERRED_SET';
export const UI_TOPIC_DESCRIPTION_TOGGLE = 'UI_TOPIC_DESCRIPTION_TOGGLE';
export const UI_TOPIC_POSTS_ORDER_BY_CHANGED =
  'UI_TOPIC_POSTS_ORDER_BY_CHANGED';
export const UI_RIGHT_PANEL_CLOSE = 'UI_RIGHT_PANEL_CLOSE';
export const UI_RIGHT_PANEL_OPEN = 'UI_RIGHT_PANEL_OPEN';
export const UI_SIDEBAR_CLOSE = 'UI_SIDEBAR_CLOSE';
export const UI_SIDEBAR_TOGGLE = 'UI_SIDEBAR_TOGGLE';
export const UI_SIDEBAR_TOGGLE_SECTION = 'UI_SIDEBAR_TOGGLE_SECTION';
export const UI_ORGANIZATION_SUMMARY_COLLAPSED =
  'UI_ORGANIZATION_SUMMARY_COLLAPSED';
export const UI_USER_PROFILE_COLLAPSED = 'UI_USER_PROFILE_COLLAPSED';
export const UI_TOAST_CLEAR = 'UI_TOAST_CLEAR';
export const UI_TOAST_PUSH = 'UI_TOAST_PUSH';
export const UI_TOAST_REMOVE = 'UI_TOAST_REMOVE';
export const UI_TOPIC_TOGGLE = 'UI_TOPIC_TOGGLE';
export const UI_HELP_MENU_OPEN_CHANGED = 'UI_HELP_MENU_OPEN_CHANGED';
export const UI_HELP_MENU_OPEN_TOGGLED = 'UI_HELP_MENU_OPEN_TOGGLED';
export const UI_POST_TOPIC_SELECT_OPEN_CHANGED =
  'UI_POST_TOPIC_SELECT_OPEN_CHANGED';
export const UI_HELP_MENU_VISIBLE_CHANGED = 'UI_HELP_MENU_VISIBLE_CHANGED';
export const UI_RECENTLY_USED_EMOJIS_ADDED = 'UI_RECENTLY_USED_EMOJIS_ADDED';
export const UI_RECENTLY_VIEWED_POSTS_ADDED = 'UI_RECENTLY_VIEWED_POSTS_ADDED';
export const UI_RECENTLY_VIEWED_POSTS_REMOVED =
  'UI_RECENTLY_VIEWED_POSTS_REMOVED';
export const UI_EMOJI_SKIN_TONE_CHANGED = 'UI_EMOJI_SKIN_TONE_CHANGED';
export const UI_CODE_BLOCK_SYNTAX_CHANGED = 'UI_CODE_BLOCK_SYNTAX_CHANGED';
export const UI_INTEGRATION_BANNER_HIDE = 'UI_INTEGRATION_BANNER_HIDE';
export const UI_CLOSE_PLATFORM_TAB = 'UI_CLOSE_PLATFORM_TAB';
export const UI_DISMISS_SEARCH_CONNECTION_PROMPT =
  'UI_DISMISS_SEARCH_CONNECTION_PROMPT';
export const UI_ADD_USED_TEMPLATE = 'UI_ADD_USED_TEMPLATE';
export const UI_ADD_MENTIONED_USER = 'UI_ADD_MENTIONED_USER';
export const UI_SET_EXTERNAL_TOPBAR_LOGIN_REDIRECT_PATH =
  'UI_SET_EXTERNAL_TOPBAR_LOGIN_REDIRECT_PATH';
export const UI_SET_EXTERNAL_POSTS_ORDER = 'UI_SET_EXTERNAL_POSTS_ORDER';
export const UI_SET_DRAFTS_ORDER = 'UI_SET_DRAFTS_ORDER';
